module.exports = __webpack_public_path__ + "img/03.d1996b11.png";